import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import DigitizeImg from "../../images/location_new/fold5/img04.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Digitize(props) {
  return (
    <div className="digitize_sec p-100" style={{ backgroundColor: "#644296" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Strategic Software Solutions for Business Digitization in Austin
            </h2>
            <p>
              Austin, known for its innovative spirit and diverse business
              culture, demands a different approach to software development. Our
              strategic software solutions offer businesses the competitive edge
              they need to navigate this dynamic environment successfully. We
              understand the importance of aligning software with specific
              business goals and customer needs.
            </p>
            <p>
              Our commitment to Austin businesses is not merely about software;
              it's about achieving a digital transformation that enhances
              operational efficiency, customer engagement, and, ultimately,
              growth. We embrace the latest technologies and market insights to
              deliver strategies and solutions that foster progress. By choosing
              strategic software solutions, you're not just adapting to Austin's
              digital revolution; you're strategically leading it.
            </p>
            <Link
              style={{
                backgroundColor: "#fff",
                color: "#644296",
                border: "1px solid #644296",
              }}
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="digitize_img">
            <LazyLoadImage
              src={DigitizeImg}
              effect="blur"
              alt="Image"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Digitize;
